import type { Incident, Unschedule } from "../models/Incidents.ts";

export function getIncidentRecordBranchId(record: Incident): number {
  const schedule = record?.schedule as
    | {
        branchId?: number;
        branch?: { id?: number };
        partner?: { candidate?: { branch?: { id?: number } } };
      }
    | undefined;

  const fromSchedule = Number(
    schedule?.branchId ?? schedule?.branch?.id ?? 0
  );
  if (fromSchedule > 0) {
    return fromSchedule;
  }

  return Number(schedule?.partner?.candidate?.branch?.id ?? 0);
}

export function getIncidentBranchName(
  record: Incident,
  branchNameById: Record<number, string> = {}
): string {
  const schedule = record?.schedule as
    | { branch?: { name?: string } }
    | undefined;
  const fromSchedule = String(schedule?.branch?.name ?? "").trim();
  if (fromSchedule) {
    return fromSchedule;
  }
  const branchId = getIncidentRecordBranchId(record);
  return branchId > 0 ? String(branchNameById[branchId] ?? "").trim() : "";
}

export function getUnscheduleBranchName(
  unschedule: Unschedule,
  branchNameById: Record<number, string> = {}
): string {
  const row = unschedule as Unschedule & { branch?: { name?: string } };
  const fromRow = String(row.branch?.name ?? "").trim();
  if (fromRow) {
    return fromRow;
  }
  const branchId = getUnscheduleBranchId(unschedule);
  return branchId > 0 ? String(branchNameById[branchId] ?? "").trim() : "";
}

export function getUnscheduleBranchId(unschedule: Unschedule): number {
  const row = unschedule as Unschedule & {
    branchId?: number;
    branch?: { id?: number };
  };
  const direct = Number(row.branchId ?? row.branch?.id ?? 0);
  if (direct > 0) {
    return direct;
  }
  return Number(unschedule.partner?.candidate?.branch?.id ?? 0);
}

/** Registro sintético para parear checadas no programadas como en RowIncident. */
export function buildUnscheduleIncidentRecord(
  unschedule: Unschedule,
  operationDate?: string
) {
  const branchId = getUnscheduleBranchId(unschedule);
  const exactDate =
    operationDate ||
    (unschedule.checkIn?.checkDate
      ? String(unschedule.checkIn.checkDate).slice(0, 10)
      : "");

  return {
    checkIn: unschedule.checkIn,
    checkOut: unschedule.checkOut,
    schedule: {
      exactDate,
      partner: unschedule.partner,
      branchId,
      branch: unschedule.branch,
      checks: dedupeChecksById([
        ...(unschedule.checks ?? []),
        unschedule.checkIn,
        unschedule.checkOut,
      ]),
    },
  };
}

function dedupeChecksById(
  checks: Array<{ id?: number; checkTime?: string } | null | undefined>
) {
  const byId = new Map<number, (typeof checks)[number]>();
  for (const check of checks) {
    if (!check?.checkTime) continue;
    const id = Number(check.id);
    if (Number.isFinite(id) && id > 0) {
      byId.set(id, check);
    }
  }
  if (byId.size > 0) {
    return [...byId.values()];
  }
  return checks.filter((check) => check?.checkTime);
}

export function collectIncidentBranchIds(
  records: Incident[],
  unschedule: Unschedule[],
  extraBranchIds: number[] = []
): number[] {
  const ids = new Set<number>();
  for (const record of records || []) {
    const branchId = getIncidentRecordBranchId(record);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  for (const row of unschedule || []) {
    const branchId = getUnscheduleBranchId(row);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  for (const id of extraBranchIds) {
    const branchId = Number(id);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  return [...ids].sort((a, b) => a - b);
}
